// const comparePriceInBtn = document.querySelector(
//     ".product-form__submit .add-to-cart-comparePrice"
// );

// document.addEventListener("sealsubs:subscription_widget_created", function(e) {
//     /* To add custom elements to subscription widget */

//     const targetElements = document.querySelectorAll(
//         ".template-adaptolatte-redesign .sls-selling-plan-group-options"
//     );
//     const subscriptionDiv = document.querySelector(".subscription_custom_info");
//     const subscriptionImage = document.querySelector(
//         ".subscription_image img"
//     ).outerHTML;

//     const subscriptionContainers = document.querySelectorAll(
//         ".template-adaptolatte-redesign .sls-option-container[data-selling-plan-group]"
//     );
//     const subscriptionSaverText = document.querySelector(
//         ".subscription_saver_text"
//     );

//     // Insert subscription_custom_info after each .sls-selling-plan-group-options
//     if (subscriptionDiv && targetElements.length > 0) {
//         targetElements.forEach((targetElement) => {
//             const subscriptionInfoDiv = document.createElement("div");
//             subscriptionInfoDiv.classList.add("subscription_custom_info");
//             if (subscriptionImage) {}
//             subscriptionInfoDiv.innerHTML = subscriptionImage ?
//                 subscriptionDiv.innerHTML + subscriptionImage :
//                 subscriptionDiv.innerHTML;
//             subscriptionInfoDiv.innerHTML =
//                 subscriptionDiv.innerHTML + subscriptionImage;

//             targetElement.parentNode.insertBefore(
//                 subscriptionInfoDiv,
//                 targetElement.nextSibling
//             );
//         });
//     }

//     // Prepend promo banner to each .sls-option-container
//     if (subscriptionSaverText && subscriptionContainers.length > 0) {
//         subscriptionContainers.forEach((container) => {
//             const newDiv = document.createElement("div");
//             newDiv.textContent = subscriptionSaverText.innerHTML;
//             newDiv.className = "subscription_promo_banner";
//             container.prepend(newDiv);
//         });
//     }
// });

// document.addEventListener("sealsubs:price_update", function(e) {
//     /* To update buy button prices */
//     const priceField = document.querySelector(
//         ".template-adaptolatte-redesign .price__regular .price-item--regular"
//     );

//     const price = e.detail.price / 100;
//     const compareAtAmount = e.detail.compareAtAmount / 100;
//     document.querySelector(
//         ".product-form__submit .add-to-cart-price"
//     ).textContent = formattedPrice(price);
//     if (comparePriceInBtn) {
//         comparePriceInBtn.textContent = formattedPrice(compareAtAmount);
//     }
// });

// const formattedPrice = (price) => {
//     return price.toLocaleString("ja-JP", {
//         style: "currency",
//         currency: "JPY",
//         minimumFractionDigits: 0,
//     });
// };

// const variantRadios = document.querySelector("variant-radios");

// if (variantRadios) {
//     variantRadios.addEventListener("change", () => {
//         const variant = variantRadios.currentVariant;
//         if (variant) {
//             updatePerServingPrices(variant);
//         }
//     });

//     window.addEventListener("DOMContentLoaded", () => {
//         variantRadios.dispatchEvent(new Event("change", {
//             bubbles: true
//         }));
//     });
// }

// document.addEventListener("sealsubs:selling_plan_changed", function(e) {
//     const updatedVariant = variantRadios.currentVariant;
//     updatePerServingPrices(updatedVariant);

//     if (comparePriceInBtn) {
//         comparePriceInBtn.style.display = e.detail.selling_plan_id ?
//             "block" :
//             "none";
//     }
// });

// const addToCartBtn = document.querySelectorAll(".js-add-upsell-product");
// if (addToCartBtn.length > 0) {
//     addToCartBtn.forEach((button) => {
//         button.addEventListener("click", async (e) => {
//             const variantId = parseInt(button.getAttribute("data-variant-id"));
//             const sellingPlanId = parseInt(button.getAttribute("data-selling-plan"));

//             try {
//                 const addToCartResponse = await fetch("/cart/add.js", {
//                     method: "POST",
//                     headers: {
//                         "Content-Type": "application/json",
//                         Accept: "application/json",
//                     },
//                     body: JSON.stringify({
//                         items: [{
//                             id: variantId,
//                             quantity: 1,
//                             selling_plan: sellingPlanId
//                         }, ],
//                     }),
//                 });

//                 if (!addToCartResponse.ok) throw new Error("Add to cart failed");

//                 const sectionsResponse = await fetch(
//                     "/?sections=cart-drawer,cart-icon-bubble"
//                 );
//                 const sectionData = await sectionsResponse.json();

//                 const cartDrawer = document.querySelector("cart-drawer");
//                 cartDrawer.renderContents({
//                     id: variantId,
//                     sections: sectionData,
//                 });
//                 cartDrawer.classList.remove("is-empty");
//             } catch (error) {
//                 console.error("Error adding to cart:", error);
//             }
//         });
//     });
// }

// function updatePerServingPrices(currentVariant) {
//     // console.log("current", currentVariant);
//     const flavourOption = currentVariant.option3;
//     const packing = currentVariant.option1;
//     const variantSelectList = document.querySelectorAll(
//         ".js-variant-list-prices select option"
//     );
//     const quantityOptions = document.querySelectorAll(
//         ".product-form__input.option--2 label"
//     );
//     const purchaseTypeField = document.querySelector(
//         ".template-adaptolatte-redesign .sealsubs-target-element input[type='radio']:checked"
//     );

//     const purchaseType =
//         purchaseTypeField == null ? "subscription" : purchaseTypeField.dataset.type;

//     if (variantSelectList.length > 0) {
//         variantSelectList.forEach((option) => {
//             if (
//                 option.innerText.includes(flavourOption) &&
//                 option.innerText.includes(packing)
//             ) {
//                 // console.log(option);
//                 if (option.innerText.includes("30杯")) {
//                     quantityOptions[0].querySelector(
//                             ".option__priceSavingValue"
//                         ).innerText =
//                         purchaseType == "subscription" ?
//                         option.dataset.subcPrice :
//                         option.dataset.onetimePrice;
//                 } else if (option.innerText.includes("60杯")) {
//                     quantityOptions[1].querySelector(
//                             ".option__priceSavingValue"
//                         ).innerText =
//                         purchaseType == "subscription" ?
//                         option.dataset.subcPrice :
//                         option.dataset.onetimePrice;
//                 } else if (option.innerText.includes("90杯")) {
//                     quantityOptions[2].querySelector(
//                             ".option__priceSavingValue"
//                         ).innerText =
//                         purchaseType == "subscription" ?
//                         option.dataset.subcPrice :
//                         option.dataset.onetimePrice;
//                 }
//             }
//         });
//     }
// }

// /* Double subscrioption logic*/

// const container = document.querySelector('.double-subscription-purchase_container');

// if (container != null) {
//     const purchaseRadios = document.querySelectorAll('.subscription-step-1 [type="radio"][name="subscriptionPurchase"]');
//     const nextButton = document.querySelector('.js-subscription-next-step');
//     const backButton = document.querySelector('.js-subscriptions-list-back-btn');
//     const addToCartBtn = document.querySelector('.product-form__submit');
//     const variantPickerContainer = document.querySelector('.variant_picker_redesigned');
//     const sellingItems = document.querySelectorAll('.js-selling-item');
//     const sellingItemsOptions = document.querySelectorAll('.selling-item.second-step-item');

//     /* Make double subscription Original + Decaf as default on page load */
//     let purchaseValue = 'double-sub';
//     document.querySelector('.double-sub.js-option-container > div').click();
//     document.querySelector(`.double-subscription-variants .product-form__input.option--2 input[value="オリジナル（モカ）+ デカフェ（ココア）"]`).checked = true;
//     document.querySelector(`.subscription-step-2 .double-sub > div`).click();




//     if (variantRadios) {
//         variantRadios.addEventListener("change", () => {
//             const variant = variantRadios.currentVariant;
//             if (variant.option1) {
//                 document.querySelectorAll('.selling-item__images img').forEach(image => {
//                     image.classList.contains(`image--${variant.option1}`) ? image.classList.remove('hidden') : image.classList.add('hidden');
//                 });

//                 const typeMap = {
//                     'パウチ': 'pouch',
//                     'トラベルパック': 'travel-pack'
//                 };

//                 const targetClass = typeMap[variant.option1] || '';

//                 document.querySelectorAll('.selling-item__bullets').forEach(list => {
//                     list.classList.toggle('hidden', !list.classList.contains(targetClass));
//                 });

//             }
//         });


//     }

//     sellingItems.forEach((item) => {
//         item.addEventListener("click", (e) => {
//             sellingItems.forEach((sellingItem) => {
//                 sellingItem.classList.remove('active');
//             });

//             item.classList.add('active');
//             purchaseValue = item.dataset.plan;
//             document.querySelector('.subscription-step-2 h2').innerText = item.querySelector('.selling-item__title').dataset.title;
//             document.querySelectorAll(`.subscription-step-2 .js-option-container`).forEach((div) => {
//                 div.classList.add('hidden');
//             });

//             const activePlanDiv = document.querySelector(`.subscription-step-2 .${purchaseValue}`);
//             activePlanDiv.classList.remove('hidden');
//             document.querySelector(`.double-subscription-variants .product-form__input.option--2 input[value="${activePlanDiv.children[0].dataset.flavourOption}"]`).checked = true;
//             document.querySelector(`.subscription-step-2 .${purchaseValue} > div`).click();
//             if (purchaseValue == 'one-time') {
//                 document.querySelector('.sls-purchase-options-container').lastElementChild.click();
//             } else if (purchaseValue == 'single-sub') {
//                 document.querySelectorAll('.sls-option-container')[0].click();
//             } else if (purchaseValue == 'double-sub') {
//                 document.querySelectorAll('.sls-option-container')[1].click();
//             }
//         });
//     });

//     sellingItemsOptions.forEach((item) => {
//         item.addEventListener("click", (e) => {
//             sellingItemsOptions.forEach((sellingItem) => {
//                 sellingItem.classList.remove('active');
//             });
//             item.classList.add('active');
//             const inputRadio = document.querySelector(`.double-subscription-variants .product-form__input.option--2 input[value="${item.dataset.flavourOption}"]`);

//             if (inputRadio) {
//                 inputRadio.checked = true;
//                 inputRadio.dispatchEvent(new Event('change', {
//                     bubbles: true
//                 }));
//             }



//         });
//     });

//     nextButton.addEventListener("click", (e) => {

//         [addToCartBtn, variantPickerContainer, backButton, document.querySelector('.subscription-step-2')].forEach(el => el?.classList.remove('hidden'));
//         [nextButton, document.querySelector('.subscription-step-1')].forEach(el => el?.classList.add('hidden'));

//     });

//     backButton.addEventListener("click", (e) => {
//         [addToCartBtn, variantPickerContainer, document.querySelector('.subscription-step-2'), backButton].forEach(el => el?.classList.add('hidden'));
//         [nextButton, document.querySelector('.subscription-step-1')].forEach(el => el?.classList.remove('hidden'));
//     });
// }


const comparePriceInBtn = document.querySelector(
    ".product-form__submit .add-to-cart-comparePrice"
);

document.addEventListener("sealsubs:subscription_widget_created", function(e) {
    /* To add custom elements to subscription widget */

    const targetElements = document.querySelectorAll(
        ".template-adaptolatte-redesign .sls-selling-plan-group-options"
    );
    const subscriptionDiv = document.querySelector(".subscription_custom_info");
    const subscriptionImage = document.querySelector(
        ".subscription_image img"
    ).outerHTML;

    const subscriptionContainers = document.querySelectorAll(
        ".template-adaptolatte-redesign .sls-option-container[data-selling-plan-group]"
    );
    const subscriptionSaverText = document.querySelector(
        ".subscription_saver_text"
    );

    // Insert subscription_custom_info after each .sls-selling-plan-group-options
    if (subscriptionDiv && targetElements.length > 0) {
        targetElements.forEach((targetElement) => {
            const subscriptionInfoDiv = document.createElement("div");
            subscriptionInfoDiv.classList.add("subscription_custom_info");
            if (subscriptionImage) {}
            subscriptionInfoDiv.innerHTML = subscriptionImage ?
                subscriptionDiv.innerHTML + subscriptionImage :
                subscriptionDiv.innerHTML;
            subscriptionInfoDiv.innerHTML =
                subscriptionDiv.innerHTML + subscriptionImage;

            targetElement.parentNode.insertBefore(
                subscriptionInfoDiv,
                targetElement.nextSibling
            );
        });
    }

    // Prepend promo banner to each .sls-option-container
    if (subscriptionSaverText && subscriptionContainers.length > 0) {
        subscriptionContainers.forEach((container) => {
            const newDiv = document.createElement("div");
            newDiv.textContent = subscriptionSaverText.innerHTML;
            newDiv.className = "subscription_promo_banner";
            container.prepend(newDiv);
        });
    }
});

document.addEventListener("sealsubs:price_update", function(e) {
    const selectedPlanElement = document.querySelector('.selling-item.js-selling-item.active');
    const addToCartPrice = document.querySelector(".product-form__submit .add-to-cart-price");
    const comparePriceInBtn = document.querySelector(".product-form__submit .add-to-cart-comparePrice");

    if (!selectedPlanElement) return;

    const planType = selectedPlanElement.dataset.plan; // single-sub, double-sub, one-time
    const price = e.detail.price / 100;
    const compareAtAmount = e.detail.compareAtAmount / 100;

    if(planType === 'one-time') {
        // Show only variant price
        addToCartPrice.textContent = formattedPrice(compareAtAmount); // variant price as regular
        if(comparePriceInBtn) comparePriceInBtn.textContent = '';
    } else {
        // Show subscription prices: regular = app price, compare = variant price
        addToCartPrice.textContent = formattedPrice(price); // app price
        if(comparePriceInBtn) comparePriceInBtn.textContent = formattedPrice(compareAtAmount);
    }
});

const formattedPrice = (price) => {
    return price.toLocaleString("ja-JP", {
        style: "currency",
        currency: "JPY",
        minimumFractionDigits: 0,
    });
};


const variantRadios = document.querySelector("variant-radios");

if (variantRadios) {
    variantRadios.addEventListener("change", () => {
        const variant = variantRadios.currentVariant;
        if (variant) {
            updatePerServingPrices(variant);
        }
    });

    window.addEventListener("DOMContentLoaded", () => {
        variantRadios.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    });
}

document.addEventListener("sealsubs:selling_plan_changed", function(e) {
    const updatedVariant = variantRadios.currentVariant;
    updatePerServingPrices(updatedVariant);

    if (comparePriceInBtn) {
        comparePriceInBtn.style.display = e.detail.selling_plan_id ?
            "block" :
            "none";
    }
});

const addToCartBtn = document.querySelectorAll(".js-add-upsell-product");
if (addToCartBtn.length > 0) {
    addToCartBtn.forEach((button) => {
        button.addEventListener("click", async (e) => {
            const variantId = parseInt(button.getAttribute("data-variant-id"));
            const sellingPlanId = parseInt(button.getAttribute("data-selling-plan"));

            try {
                const addToCartResponse = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify({
                        items: [{
                            id: variantId,
                            quantity: 1,
                            selling_plan: sellingPlanId
                        }, ],
                    }),
                });

                if (!addToCartResponse.ok) throw new Error("Add to cart failed");

                const sectionsResponse = await fetch(
                    "/?sections=cart-drawer,cart-icon-bubble"
                );
                const sectionData = await sectionsResponse.json();

                const cartDrawer = document.querySelector("cart-drawer");
                cartDrawer.renderContents({
                    id: variantId,
                    sections: sectionData,
                });
                cartDrawer.classList.remove("is-empty");
            } catch (error) {
                console.error("Error adding to cart:", error);
            }
        });
    });
}

function updatePerServingPrices(currentVariant) {
    // console.log("current", currentVariant);
    const flavourOption = currentVariant.option3;
    const packing = currentVariant.option1;
    const variantSelectList = document.querySelectorAll(
        ".js-variant-list-prices select option"
    );
    const quantityOptions = document.querySelectorAll(
        ".product-form__input.option--2 label"
    );
    const purchaseTypeField = document.querySelector(
        ".template-adaptolatte-redesign .sealsubs-target-element input[type='radio']:checked"
    );

    const purchaseType =
        purchaseTypeField == null ? "subscription" : purchaseTypeField.dataset.type;

    if (variantSelectList.length > 0) {
        variantSelectList.forEach((option) => {
            if (
                option.innerText.includes(flavourOption) &&
                option.innerText.includes(packing)
            ) {
                // console.log(option);
                if (option.innerText.includes("30杯")) {
                    quantityOptions[0].querySelector(
                            ".option__priceSavingValue"
                        ).innerText =
                        purchaseType == "subscription" ?
                        option.dataset.subcPrice :
                        option.dataset.onetimePrice;
                } else if (option.innerText.includes("60杯")) {
                    quantityOptions[1].querySelector(
                            ".option__priceSavingValue"
                        ).innerText =
                        purchaseType == "subscription" ?
                        option.dataset.subcPrice :
                        option.dataset.onetimePrice;
                } else if (option.innerText.includes("90杯")) {
                    quantityOptions[2].querySelector(
                            ".option__priceSavingValue"
                        ).innerText =
                        purchaseType == "subscription" ?
                        option.dataset.subcPrice :
                        option.dataset.onetimePrice;
                }
            }
        });
    }
}

/* Double subscrioption logic*/

const container = document.querySelector('.double-subscription-purchase_container');

if (container != null) {
    const purchaseRadios = document.querySelectorAll('.subscription-step-1 [type="radio"][name="subscriptionPurchase"]');
    const nextButton = document.querySelector('.js-subscription-next-step');
    const backButton = document.querySelector('.js-subscriptions-list-back-btn');
    const addToCartBtn = document.querySelector('.product-form__submit');
    const variantPickerContainer = document.querySelector('.variant_picker_redesigned');
    const sellingItems = document.querySelectorAll('.js-selling-item');
    const sellingItemsOptions = document.querySelectorAll('.selling-item.second-step-item');

    /* Make double subscription Original + Decaf as default on page load */
    let purchaseValue = 'double-sub';
    document.querySelector('.double-sub.js-option-container > div').click();
    document.querySelector(`.double-subscription-variants .product-form__input.option--2 input[value="オリジナル（モカ）+ デカフェ（ココア）"]`).checked = true;
    document.querySelector(`.subscription-step-2 .double-sub > div`).click();




    if (variantRadios) {
        variantRadios.addEventListener("change", () => {
            const variant = variantRadios.currentVariant;
            if (variant.option1) {
                document.querySelectorAll('.selling-item__images img').forEach(image => {
                    image.classList.contains(`image--${variant.option1}`) ? image.classList.remove('hidden') : image.classList.add('hidden');
                });

                const typeMap = {
                    'パウチ': 'pouch',
                    'トラベルパック': 'travel-pack'
                };

                const targetClass = typeMap[variant.option1] || '';

                document.querySelectorAll('.selling-item__bullets').forEach(list => {
                    list.classList.toggle('hidden', !list.classList.contains(targetClass));
                });

            }
        });


    }

    sellingItems.forEach((item) => {
        item.addEventListener("click", (e) => {
            sellingItems.forEach((sellingItem) => {
                sellingItem.classList.remove('active');
            });

            item.classList.add('active');
            purchaseValue = item.dataset.plan;
            document.querySelector('.subscription-step-2 h2').innerText = item.querySelector('.selling-item__title').dataset.title;
            document.querySelectorAll(`.subscription-step-2 .js-option-container`).forEach((div) => {
                div.classList.add('hidden');
            });

            const activePlanDiv = document.querySelector(`.subscription-step-2 .${purchaseValue}`);
            activePlanDiv.classList.remove('hidden');
            document.querySelector(`.double-subscription-variants .product-form__input.option--2 input[value="${activePlanDiv.children[0].dataset.flavourOption}"]`).checked = true;
            document.querySelector(`.subscription-step-2 .${purchaseValue} > div`).click();
            if (purchaseValue == 'one-time') {
                document.querySelector('.sls-purchase-options-container').lastElementChild.click();
            } else if (purchaseValue == 'single-sub') {
                document.querySelectorAll('.sls-option-container')[0].click();
            } else if (purchaseValue == 'double-sub') {
                document.querySelectorAll('.sls-option-container')[1].click();
            }
        });
    });

    sellingItemsOptions.forEach((item) => {
        item.addEventListener("click", (e) => {
            sellingItemsOptions.forEach((sellingItem) => {
                sellingItem.classList.remove('active');
            });
            item.classList.add('active');
            const inputRadio = document.querySelector(`.double-subscription-variants .product-form__input.option--2 input[value="${item.dataset.flavourOption}"]`);

            if (inputRadio) {
                inputRadio.checked = true;
                inputRadio.dispatchEvent(new Event('change', {
                    bubbles: true
                }));
            }



        });
    });

    nextButton.addEventListener("click", (e) => {

        [addToCartBtn, variantPickerContainer, backButton, document.querySelector('.subscription-step-2')].forEach(el => el?.classList.remove('hidden'));
        [nextButton, document.querySelector('.subscription-step-1')].forEach(el => el?.classList.add('hidden'));

    });

    backButton.addEventListener("click", (e) => {
        [addToCartBtn, variantPickerContainer, document.querySelector('.subscription-step-2'), backButton].forEach(el => el?.classList.add('hidden'));
        [nextButton, document.querySelector('.subscription-step-1')].forEach(el => el?.classList.remove('hidden'));
    });
}